import * as R from 'ramda';
import GeneratedDocumentWatcher from './GeneratedDocumentWatcher';

export default function GenerateDocumentDialogController(
  $cookies,
  $rootScope,
  $scope,
  $q,
  ssDialogService,
  loaderService,
  alerts,
  ecatDataService,
  reportsDataService,
) {
  const vm = this;
  const generatedDocumentWatcher = new GeneratedDocumentWatcher($rootScope, $cookies);

  vm.submitButtonText = 'Generate Assessment';

  vm.saveDocument = false;
  vm.renderFullDocument = true;
  vm.isDocumentIndeterminate = true;

  vm.handleCloseDialog = _handleCloseDialog;

  vm.handleRunReport = _handleRunReport;
  vm.handleFullReport = _handleFullReport;
  vm.handleSelectReport = _handleSelectReport;

  vm.noneChecked = _noneChecked;
  vm.noneCheckedMessage = _noneCheckedMessage;

  vm.reports = [];

  _activate();

  /** ************************************************
   * Event Handlers
   */

  function _activate() {
    _initPermissions();
    _initEventListeners();
    _initReports();
  }

  function _initPermissions() {}

  function _initEventListeners() {}

  function _handleCloseDialog() {
    _closeDialog();
  }

  function _handleRunReport() {
    console.log('_handleRunReport');
    const dfdSave = $q.defer();

    if ($scope.ecatGenerateDocumentForm.$valid) {
      const reportSections = R.join(
        ',',
        R.pluck(
          'reportSectionId',
          R.filter(R.allPass([R.propEq('isSelected', true), R.propEq('isActive', true)]), vm.reports),
        ),
      );

      alerts.info('Please Wait! Queueing report. It may take little longer than normal to get the report');
      loaderService.showViewLoader = true;
      const downloadCall = ecatDataService.generateFullReport({
        assessmentId: vm.assessment.assessmentId,
        name: vm.assessment.name,
        reportSection: reportSections,
        renderFullReport: vm.renderFullDocument,
        saveDocument: vm.saveDocument,
      });

      downloadCall.then(downloadDocumentResponse => {
        alerts.success('The ECAT Assessment Document was generated successfully.');
        loaderService.showViewLoader = false;
        generatedDocumentWatcher.setDocumentComplete();
        reportsDataService.download(downloadDocumentResponse);
        generatedDocumentWatcher.checkDocumentComplete(1);
        $rootScope.$broadcast('refreshECATAssessments');
      });

      _handleCloseDialog();
      dfdSave.resolve();
    } else {
      dfdSave.reject();
    }
  }

  function _handleFullReport() {
    R.forEach(report => {
      report.isSelected = vm.renderFullDocument;
    }, vm.reports);
  }

  function _handleSelectReport() {
    const reportsShown = R.filter(R.propEq('isActive', true), vm.reports);

    if (reportsShown !== null) {
      const reportsSelected = R.filter(R.propEq('isSelected', true), reportsShown);

      if (reportsSelected !== null) {
        vm.renderFullDocument = reportsShown.length === reportsSelected.length;
      }
    }
  }

  // Validation
  function _noneChecked() {
    const selected = R.filter(R.allPass([R.propEq('isSelected', true), R.propEq('isActive', true)]), vm.reports);

    return R.isNil(selected) || selected.length === 0;
  }

  function _noneCheckedMessage(form) {
    let result = null;
    if (form) {
      const selected = angular.element('input:checked[name="renderReportSec"]');

      if (selected || selected.length === 0) {
        const ctrl = form.renderFullDocument;
        if (ctrl) {
          result = ctrl.$error;
        }
      }
    }
    return result;
  }

  /** ************************************************
   * Private Functions
   */

  function _closeDialog() {
    ssDialogService.hide(ssDialogService.dialogs.ecat.generateDocumentDialog);
  }

  function _initReports() {
    if (vm.assessment.usesInherentRiskProfile) {
      const irReportSection = {
        title: 'Inherent Risk Profile',
        reportSectionId: 1,
        isSelected: true,
        isActive: true,
      };

      vm.reports.push(irReportSection);
    }

    if (vm.assessment.usesMaturityProfile) {
      const irReportSection = {
        title: 'Maturity Profile',
        reportSectionId: 2,
        isSelected: true,
        isActive: true,
      };

      vm.reports.push(irReportSection);
    }

    if (vm.assessment.usesCRIProfile) {
      const irReportSection = {
        title: 'CRI Profile',
        reportSectionId: 3,
        isSelected: true,
        isActive: true,
      };

      vm.reports.push(irReportSection);
    }
  }
}

GenerateDocumentDialogController.$inject = [
  '$cookies',
  '$rootScope',
  '$scope',
  '$q',
  'ssDialogService',
  'loaderService',
  'alerts',
  'ecatDataService',
  'reportsDataService',
];
